/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Users_Detail_Validity_DaysInputs */

const en_users_detail_validity_days = /** @type {(inputs: Users_Detail_Validity_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} days`)
};

const pt_br2_users_detail_validity_days = /** @type {(inputs: Users_Detail_Validity_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias`)
};

/**
* | output |
* | --- |
* | "{days} days" |
*
* @param {Users_Detail_Validity_DaysInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_validity_days = /** @type {((inputs: Users_Detail_Validity_DaysInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_Validity_DaysInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_validity_days(inputs)
	return pt_br2_users_detail_validity_days(inputs)
});